
import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';

export default function CookieConsent() {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 border-t border-border bg-card shadow-lg z-50">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between px-4 py-4 pr-20 sm:flex-row sm:px-6 sm:pr-24 lg:px-8 lg:pr-24">
        {/* Right gutter (pr-20/24) is reserved for the EzyChat contact bubble. */}
        <div className="mb-4 text-sm text-neutral-muted sm:mb-0">
          We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.
          <a href="/privacy-policy/" className="ml-1 text-primary underline underline-offset-2">Learn more</a>
        </div>
        <div className="flex space-x-4">
          <Button
            onClick={acceptCookies}
            className="bg-primary hover:bg-primary/90"
          >
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
}
